import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setShipmentProductDimUomList } from '../common/CommonActions';
import { getQuoteProductDimUomListEffect } from '../shipment/ShipmentEffects';

// todo: should be moved to data-provider/api.ts DimUomListResponse
export type DimUom = {
  codeId: string;
  codeDesc: string;
  value1: string;
  value2: string;
  value3: string;
  string1: string | null;
  string2: string | null;
  string3: string | null;
};

const useQuoteProductDimUomList = (): DimUom[] => {
  const [list, setList] = useState<DimUom[] | []>([]);
  const { shipmentProductDimUomList } = useSelector((state: any) => state.common);
  const dispatch = useDispatch();

  useEffect(() => {
    if (shipmentProductDimUomList.success) {
      setList(shipmentProductDimUomList.data);
    } else {
      getList();
    }
  }, [shipmentProductDimUomList]);

  const getList = async () => {
    try {
      dispatch(setShipmentProductDimUomList({ success: true, data: [] }));
      const { data } = await getQuoteProductDimUomListEffect();
      setList(data);
      dispatch(setShipmentProductDimUomList({ success: true, data }));
    } catch {
      setList([]);
    }
  };

  return list;
};

export default useQuoteProductDimUomList;
